module.exports = __webpack_public_path__ + "static/media/hiw13.6b6aa1b9.svg";